<template>
<svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 90 90">
  <path class="cls-4" d="m77.2,79.66H11.44c-.99,0-1.79-.8-1.79-1.79V12.13c0-.99.8-1.79,1.79-1.79s1.79.8,1.79,1.79v63.96h63.97c.99,0,1.79.8,1.79,1.79s-.8,1.79-1.79,1.79Z"/>
  <path class="cls-4" d="m11.44,67.91c-.42,0-.84-.15-1.18-.45-.74-.65-.81-1.78-.15-2.52l9.14-10.34c.33-.37.79-.59,1.28-.6.48-.02.97.17,1.32.52l6.84,6.8,31.45-36.63c.61-.71,1.66-.83,2.41-.28l6.42,4.72,6.82-8.65c.61-.77,1.73-.91,2.51-.3.77.61.91,1.73.3,2.51l-7.89,10.01c-.6.76-1.68.9-2.46.33l-6.48-4.76-31.63,36.83c-.32.38-.79.6-1.28.62-.5.02-.98-.17-1.33-.52l-6.86-6.82-7.89,8.92c-.35.4-.84.6-1.34.6Z"/>
  <g>
    <g>
      <circle class="cls-1" cx="44.32" cy="45" r="11.6"/>
      <path class="cls-2" d="m44.32,57.41c-6.84,0-12.41-5.57-12.41-12.41s5.57-12.41,12.41-12.41,12.41,5.57,12.41,12.41-5.57,12.41-12.41,12.41Zm0-23.2c-5.95,0-10.79,4.84-10.79,10.79s4.84,10.79,10.79,10.79,10.79-4.84,10.79-10.79-4.84-10.79-10.79-10.79Z"/>
    </g>
    <path class="cls-2" d="m44.32,37.26c-.11,0-.2-.09-.2-.2v-1.77c0-.11.09-.2.2-.2s.2.09.2.2v1.77c0,.11-.09.2-.2.2Z"/>
    <g>
      <line class="cls-1" x1="37.46" y1="38.14" x2="38.12" y2="38.8"/>
      <path class="cls-2" d="m38.12,39.01c-.05,0-.1-.02-.14-.06l-.67-.67c-.08-.08-.08-.21,0-.29s.21-.08.29,0l.67.67c.08.08.08.21,0,.29-.04.04-.09.06-.14.06Z"/>
    </g>
    <g>
      <line class="cls-1" x1="34.61" y1="45" x2="36.38" y2="45"/>
      <path class="cls-2" d="m36.38,45.2h-1.77c-.11,0-.2-.09-.2-.2s.09-.2.2-.2h1.77c.11,0,.2.09.2.2s-.09.2-.2.2Z"/>
    </g>
    <g>
      <line class="cls-1" x1="37.74" y1="51.58" x2="38.42" y2="50.91"/>
      <path class="cls-2" d="m37.75,51.78c-.05,0-.1-.02-.14-.06-.08-.08-.08-.21,0-.29l.67-.67c.08-.08.21-.08.29,0s.08.21,0,.29l-.67.67s-.09.06-.14.06Z"/>
    </g>
    <g>
      <line class="cls-1" x1="44.32" y1="54.71" x2="44.32" y2="52.94"/>
      <path class="cls-2" d="m44.32,54.91c-.11,0-.2-.09-.2-.2v-1.77c0-.11.09-.2.2-.2s.2.09.2.2v1.77c0,.11-.09.2-.2.2Z"/>
    </g>
    <g>
      <line class="cls-1" x1="50.9" y1="51.58" x2="50.23" y2="50.91"/>
      <path class="cls-2" d="m50.9,51.78c-.05,0-.1-.02-.14-.06l-.67-.67c-.08-.08-.08-.21,0-.29s.21-.08.29,0l.67.67c.08.08.08.21,0,.29-.04.04-.09.06-.14.06Z"/>
    </g>
    <g>
      <line class="cls-1" x1="54.03" y1="45" x2="52.26" y2="45"/>
      <path class="cls-2" d="m54.03,45.2h-1.77c-.11,0-.2-.09-.2-.2s.09-.2.2-.2h1.77c.11,0,.2.09.2.2s-.09.2-.2.2Z"/>
    </g>
    <g>
      <line class="cls-1" x1="50.9" y1="38.14" x2="50.23" y2="38.81"/>
      <path class="cls-2" d="m50.23,39.01c-.05,0-.1-.02-.14-.06-.08-.08-.08-.21,0-.29l.67-.67c.08-.08.21-.08.29,0s.08.21,0,.29l-.67.67s-.09.06-.14.06Z"/>
    </g>
    <g>
      <line class="cls-1" x1="34.61" y1="45" x2="36.38" y2="45"/>
      <path class="cls-2" d="m36.38,45.2h-1.77c-.11,0-.2-.09-.2-.2s.09-.2.2-.2h1.77c.11,0,.2.09.2.2s-.09.2-.2.2Z"/>
    </g>
    <g>
      <line class="cls-1" x1="44.32" y1="54.71" x2="44.32" y2="52.94"/>
      <path class="cls-2" d="m44.32,54.91c-.11,0-.2-.09-.2-.2v-1.77c0-.11.09-.2.2-.2s.2.09.2.2v1.77c0,.11-.09.2-.2.2Z"/>
    </g>
    <g>
      <line class="cls-1" x1="54.03" y1="45" x2="52.26" y2="45"/>
      <path class="cls-2" d="m54.03,45.2h-1.77c-.11,0-.2-.09-.2-.2s.09-.2.2-.2h1.77c.11,0,.2.09.2.2s-.09.2-.2.2Z"/>
    </g>
    <g>
      <polyline class="cls-1" points="41.9 38.86 44.32 45 50.56 47.88"/>
      <path class="cls-4" d="m50.56,48.49c-.09,0-.17-.02-.25-.06l-6.46-2.99-2.51-6.36c-.12-.31.03-.66.34-.79.31-.12.66.03.79.34l2.33,5.91,6.02,2.78c.3.14.44.5.3.81-.1.22-.32.35-.55.35Z"/>
    </g>
  </g>
  <circle class="cls-3" cx="20.53" cy="56.6" r="3.15"/>
  <circle class="cls-3" cx="28.76" cy="63.59" r="3.15"/>
  <circle class="cls-3" cx="61.68" cy="26.41" r="3.15"/>
  <circle class="cls-3" cx="69.2" cy="31.06" r="3.15"/>
  <circle class="cls-3" cx="77.2" cy="21.59" r="3.15"/>
</svg>
</template>

<script>
export default {
    name: "TimeAllMetricsTableIcon",
}
</script>

<style scoped>
  .cls-1 {
    fill: #fff;
  }
  .cls-2 {
    fill: #0f5b71;
  }
  .cls-3 {
    fill: #0b5e73;
  }
  .cls-4 {
    fill: #59c5c7;
  }
</style>